import { render } from "./ListCommunityView.vue?vue&type=template&id=3c2551ca"
import script from "./ListCommunityView.vue?vue&type=script&lang=js"
export * from "./ListCommunityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__